import React from 'react';
import { Paperclip } from '@phosphor-icons/react';

interface FileUplaodProps {
    handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    fileTypes: { [key: string]: string[] };
}

export default function FileUpload({ handleFileChange, fileTypes }: FileUplaodProps) {
    return fileTypes ? (
        <div className={`h-[56px] min-w-[40px] flex pr-0 justify-center items-center`}>
            <input
                id="file-upload"
                type="file"
                accept={Object.values(fileTypes).flat().join(', ')}
                multiple
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />

            <label
                htmlFor="file-upload"
                className={`text-chatInput-inlineButtonColor hover:text-chatInput-inlineButtonColor-hover  border-none rounded-s bg-transparent cursor-pointer duration-300 `}
            >
                <Paperclip size={24} color="currentColor" />
            </label>
        </div>
    ) : null;
}
